import React from 'react';
import '../../style/scss/toggle-group.scss';

export interface ToggleGroupOption<T extends string> {
    value: T;
    label: string;
}

interface ToggleGroupProps<T extends string> {
    options: ToggleGroupOption<T>[];
    value: T;
    onChange: (value: T) => void;
}

function ToggleGroup<T extends string>({ options, value, onChange }: ToggleGroupProps<T>) {
    return (
        <div className='toggle-group'>
            {/* Render one toggle button per option */}
            {options.map(option => (
                <button
                    key={option.value}
                    type='button'
                    className={`toggle-group-button${value === option.value ? ' active' : ''}`}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}

export default ToggleGroup;
